import { MUITab } from "@abb/arcadia-ui-react"
import { useContext } from "react"
import { DiMaProgress } from "../../components/DiMaProgress"
import { UserContext } from "../../context/UserContext"
import { useHashTab } from "../../../hooks/useHashTab"
import { MacAddress } from "./supplier_tab/MacAddress"
import { ManufacturedDevices } from "./supplier_tab/ManufacturedDevices"
import { ObjectIdRequests } from "./supplier_tab/ObjectIdRequests"

export function SupplierContainer() {
  const { user } = useContext(UserContext)
  const { activeTab, handleTabChange } = useHashTab("object-id")

  if (!user) {
    return <DiMaProgress />
  }

  return (
    <div>
      <MUITab
        tabItems={[
          { id: "object-id", label: "Object Ids" },
          { id: "mac-addresses", label: "Mac Addresses" },
          { id: "manufactured-devices", label: "Manufactured Devices" },
        ]}
        value={activeTab}
        handleChange={handleTabChange}
      />

      {activeTab === "object-id" && <ObjectIdRequests />}
      {activeTab === "mac-addresses" && <MacAddress />}
      {activeTab === "manufactured-devices" && <ManufacturedDevices />}
    </div>
  )
}
